module.exports = __webpack_public_path__ + "assets/icon_loading.2bdda2d.png";